import useApi, { ApiOptions } from '../base/useApi';
import { OrganisationSearchResultDTO } from './useSearchOrganisation';

interface Params {
  id: string;
}

type Result = OrganisationSearchResultDTO;

const options: ApiOptions = {
  method: 'get',
  urlPath: '/organisation',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useGetOrganisationLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useGetOrganisationLazy;
